var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 137,
    viewBox: "0 0 116 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.9991 130.83C89.9383 130.83 115.83 104.938 115.83 72.9991C115.83 41.0598 89.9383 15.168 57.9991 15.168C26.0598 15.168 0.167969 41.0598 0.167969 72.9991C0.167969 104.938 26.0598 130.83 57.9991 130.83Z",
    fill: "#F2F6FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1528 48.3242H24.8398C22.7105 48.3242 20.9844 50.0503 20.9844 52.1796V133.143C20.9844 135.272 22.7105 136.999 24.8398 136.999H91.1528C93.2821 136.999 95.0082 135.272 95.0082 133.143V52.1796C95.0082 50.0503 93.2821 48.3242 91.1528 48.3242Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.291 59.8906H30.2429C28.9654 59.8906 27.9297 60.9263 27.9297 62.2039C27.9297 63.4814 28.9654 64.5171 30.2429 64.5171H50.291C51.5686 64.5171 52.6043 63.4814 52.6043 62.2039C52.6043 60.9263 51.5686 59.8906 50.291 59.8906Z",
    fill: "#E5E9F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1705 69.916H30.2429C28.9654 69.916 27.9297 70.9517 27.9297 72.2293C27.9297 73.5068 28.9654 74.5425 30.2429 74.5425H64.1705C65.4481 74.5425 66.4837 73.5068 66.4837 72.2293C66.4837 70.9517 65.4481 69.916 64.1705 69.916Z",
    fill: "#E5E9F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.291 80.7109H30.2429C28.9654 80.7109 27.9297 81.7466 27.9297 83.0242C27.9297 84.3018 28.9654 85.3374 30.2429 85.3374H50.291C51.5686 85.3374 52.6043 84.3018 52.6043 83.0242C52.6043 81.7466 51.5686 80.7109 50.291 80.7109Z",
    fill: "#E5E9F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1705 90.7363H30.2429C28.9654 90.7363 27.9297 91.772 27.9297 93.0496C27.9297 94.3271 28.9654 95.3628 30.2429 95.3628H64.1705C65.4481 95.3628 66.4837 94.3271 66.4837 93.0496C66.4837 91.772 65.4481 90.7363 64.1705 90.7363Z",
    fill: "#E5E9F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.291 101.529H30.2429C28.9654 101.529 27.9297 102.565 27.9297 103.843C27.9297 105.12 28.9654 106.156 30.2429 106.156H50.291C51.5686 106.156 52.6043 105.12 52.6043 103.843C52.6043 102.565 51.5686 101.529 50.291 101.529Z",
    fill: "#E5E9F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1705 111.555H30.2429C28.9654 111.555 27.9297 112.59 27.9297 113.868C27.9297 115.146 28.9654 116.181 30.2429 116.181H64.1705C65.4481 116.181 66.4837 115.146 66.4837 113.868C66.4837 112.59 65.4481 111.555 64.1705 111.555Z",
    fill: "#E5E9F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6870_43060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.1528 9H24.8398C22.7105 9 20.9844 10.7261 20.9844 12.8554V35.9878C20.9844 38.1171 22.7105 39.8433 24.8398 39.8433H91.1528C93.2821 39.8433 95.0082 38.1171 95.0082 35.9878V12.8554C95.0082 10.7261 93.2821 9 91.1528 9Z",
    fill: "#A0A1B9"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2871 17.4824H30.239C28.9615 17.4824 27.9258 18.5181 27.9258 19.7957C27.9258 21.0732 28.9615 22.1089 30.239 22.1089H50.2871C51.5647 22.1089 52.6004 21.0732 52.6004 19.7957C52.6004 18.5181 51.5647 17.4824 50.2871 17.4824Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1666 27.5078H30.239C28.9615 27.5078 27.9258 28.5435 27.9258 29.8211C27.9258 31.0986 28.9615 32.1343 30.239 32.1343H64.1666C65.4442 32.1343 66.4798 31.0986 66.4798 29.8211C66.4798 28.5435 65.4442 27.5078 64.1666 27.5078Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6870_43060",
    x: 14.9844,
    y: 0,
    width: 86.0234,
    height: 42.8438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6870_43060"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6870_43060",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyResult);
export default __webpack_public_path__ + "static/media/empty-result.a38c354c4691d674c0911e45ecde62b1.svg";
export { ForwardRef as ReactComponent };